export default __webpack_public_path__ + "static/media/appStore.68ed715e.svg";